// Declares the editable "chrome" (headings, copy, images, buttons, lists) for
// each functional/embed widget. The Admin Page Editor renders a generic editor
// from this schema and stores values into the section's `content` object, which
// the widget then reads (falling back to its built-in defaults when unset).
//
// Field types:
//   text     -> single-line Input
//   textarea -> multi-line Textarea
//   image    -> AdminImageInput (media picker / URL)
//   list     -> array of strings (bullet items)
//   links    -> array of { label, to } (link cards / nav)

export const WIDGET_EDITABLE = {
  home_offer: [
    { name: "eyebrow", label: "Eyebrow (small label)", type: "text", placeholder: "Limited Time" },
    { name: "title", label: "Title", type: "text", placeholder: "CURRENT OFFER" },
  ],
  home_testimonials: [
    { name: "eyebrow", label: "Eyebrow", type: "text", placeholder: "Social Proof" },
    { name: "title", label: "Title", type: "text", placeholder: "Featured Athletes" },
    { name: "subtitle", label: "Subtitle", type: "textarea", placeholder: "Real results from real members of the Trilogy family." },
    { name: "link_label", label: "Link label", type: "text", placeholder: "See all stories" },
  ],
  home_app: [
    { name: "title", label: "Title", type: "text", placeholder: "TRILOGY APP" },
    { name: "body", label: "Body copy", type: "textarea", placeholder: "Work with the best trainers around to achieve a life of fitness…" },
    { name: "trial_text", label: "Trial banner", type: "text", placeholder: "14 DAY FREE ONLINE TRIAL" },
    { name: "image", label: "Image / logo", type: "image", help: "Defaults to the site logo when empty." },
    { name: "features", label: "Feature bullets", type: "list", help: "Defaults to App Features from Settings when empty." },
  ],
  home_quick_links: [
    { name: "links", label: "Quick link cards", type: "links" },
  ],
  home_locations: [
    { name: "eyebrow", label: "Eyebrow", type: "text", placeholder: "Find Us" },
    { name: "title", label: "Title", type: "text", placeholder: "TWO LOCATIONS" },
    { name: "subtitle", label: "Subtitle", type: "textarea", placeholder: "Train with us in Lenexa, KS and Independence, MO." },
  ],
  home_social: [
    { name: "heading", label: "Heading", type: "text", placeholder: "Follow The Movement" },
  ],
  services_grid: [
    { name: "eyebrow", label: "Eyebrow", type: "text", placeholder: "Choose Your Path" },
    { name: "title", label: "Title", type: "text", placeholder: "Programs Built For You" },
    { name: "subtitle", label: "Subtitle", type: "textarea", placeholder: "Filter by who you are or what you need, then book or view packages in one tap." },
  ],
  packages_grid: [
    { name: "client_heading", label: "'Already a Client?' heading", type: "text", placeholder: "Already a Client?" },
    { name: "client_text", label: "'Already a Client?' text", type: "textarea", placeholder: "Existing clients can manage booking and purchases inside the Trilogy app / client portal." },
    { name: "client_button_label", label: "Portal button label", type: "text", placeholder: "Open Client Portal" },
    { name: "note", label: "Checkout note", type: "textarea", placeholder: "Checkout is handled securely on Exercise.com — no card details are stored on this site." },
  ],
  mavs_core: [
    { name: "steps_eyebrow", label: "Steps · eyebrow", type: "text", placeholder: "For Parents" },
    { name: "steps_title", label: "Steps · title", type: "text", placeholder: "Get Started in 6 Steps" },
    { name: "steps_subtitle", label: "Steps · subtitle", type: "textarea", placeholder: "A simple path to get your athlete training with the Mavs." },
    { name: "app_title", label: "App band · title", type: "text", placeholder: "Get The Trilogy App" },
    { name: "app_body", label: "App band · text", type: "textarea", placeholder: "Everything for Mavs parents in one place — schedule, booking, payments, and team updates." },
    { name: "schedule_eyebrow", label: "Schedule · eyebrow", type: "text", placeholder: "Schedule" },
    { name: "schedule_title", label: "Schedule · title", type: "text", placeholder: "Practices, Tryouts & Tournaments" },
    { name: "schedule_subtitle", label: "Schedule · subtitle", type: "textarea", placeholder: "View upcoming Mavs events. Full schedule and check-in live in the Trilogy app." },
    { name: "schedule_button_label", label: "Schedule · button label", type: "text", placeholder: "See Full Schedule in App" },
    { name: "packages_eyebrow", label: "Packages · eyebrow", type: "text", placeholder: "Pricing" },
    { name: "packages_title", label: "Packages · title", type: "text", placeholder: "Mavs Packages & Camps" },
    { name: "packages_subtitle", label: "Packages · subtitle", type: "textarea", placeholder: "Memberships and camps for the Mavs program. Checkout is secure on Exercise.com." },
  ],
  mavs_steps: [
    { name: "steps_eyebrow", label: "Eyebrow", type: "text", placeholder: "For Parents" },
    { name: "steps_title", label: "Title", type: "text", placeholder: "Get Started in 6 Steps" },
    { name: "steps_subtitle", label: "Subtitle", type: "textarea", placeholder: "A simple path to get your athlete training with the Mavs." },
  ],
  mavs_app: [
    { name: "app_title", label: "Title", type: "text", placeholder: "Get The Trilogy App" },
    { name: "app_body", label: "Body copy", type: "textarea", placeholder: "Everything for Mavs parents in one place — schedule, booking, payments, and team updates." },
    { name: "setup_heading", label: "Setup box heading", type: "text", placeholder: "Quick App Setup" },
    { name: "image", label: "Logo / image", type: "image", help: "Defaults to the site logo when empty." },
  ],
  mavs_schedule: [
    { name: "schedule_eyebrow", label: "Eyebrow", type: "text", placeholder: "Schedule" },
    { name: "schedule_title", label: "Title", type: "text", placeholder: "Practices, Tryouts & Tournaments" },
    { name: "schedule_subtitle", label: "Subtitle", type: "textarea", placeholder: "View upcoming Mavs events. Full schedule and check-in live in the Trilogy app." },
    { name: "schedule_button_label", label: "Button label", type: "text", placeholder: "See Full Schedule in App" },
  ],
  mavs_packages: [
    { name: "packages_eyebrow", label: "Eyebrow", type: "text", placeholder: "Pricing" },
    { name: "packages_title", label: "Title", type: "text", placeholder: "Mavs Packages & Camps" },
    { name: "packages_subtitle", label: "Subtitle", type: "textarea", placeholder: "Memberships and camps for the Mavs program. Checkout is secure on Exercise.com." },
  ],
  mavs_highlights: [
    { name: "highlights_eyebrow", label: "Eyebrow", type: "text", placeholder: "Mavs Pride" },
    { name: "highlights_title", label: "Title", type: "text", placeholder: "Athlete Highlights" },
    { name: "highlights_subtitle", label: "Subtitle", type: "textarea", placeholder: "Celebrating the growth and success of our young athletes." },
  ],
  mavs_parents: [
    { name: "news_eyebrow", label: "Announcements · eyebrow", type: "text", placeholder: "Latest" },
    { name: "news_title", label: "Announcements · title", type: "text", placeholder: "Mavs Announcements" },
    { name: "news_subtitle", label: "Announcements · subtitle", type: "textarea", placeholder: "Important updates for parents and athletes." },
    { name: "resources_eyebrow", label: "Resources · eyebrow", type: "text", placeholder: "Resources" },
    { name: "resources_title", label: "Resources · title", type: "text", placeholder: "Program Resources" },
    { name: "resources_subtitle", label: "Resources · subtitle", type: "textarea", placeholder: "Handbooks, schedules, and registration for the Mavs program." },
  ],
  booking_start: [
    { name: "eyebrow", label: "Eyebrow (optional)", type: "text", placeholder: "e.g. Get Started" },
    { name: "title", label: "Title (optional)", type: "text", placeholder: "Leave blank to hide the heading" },
    { name: "subtitle", label: "Subtitle (optional)", type: "textarea", placeholder: "Optional intro above the guidance cards" },
  ],
  booking_options: [
    { name: "eyebrow", label: "Eyebrow", type: "text", placeholder: "Choose How To Book" },
    { name: "title", label: "Title", type: "text", placeholder: "Booking Options" },
    { name: "subtitle", label: "Subtitle", type: "textarea", placeholder: "Pick the option that fits you. Everything routes to our secure Exercise.com booking." },
  ],
  booking_scheduler: [
    { name: "eyebrow", label: "Eyebrow", type: "text", placeholder: "Live Scheduler" },
    { name: "title", label: "Title", type: "text", placeholder: "Book Online Now" },
    { name: "subtitle", label: "Subtitle", type: "textarea", placeholder: "Browse open times and book directly. Choose your location to get started." },
  ],
  locations_cards: [
    { name: "eyebrow", label: "Eyebrow (optional)", type: "text", placeholder: "e.g. Find Us" },
    { name: "title", label: "Title (optional)", type: "text", placeholder: "Leave blank to hide the heading" },
    { name: "subtitle", label: "Subtitle (optional)", type: "textarea", placeholder: "Optional intro text above the location cards" },
  ],
  locations_details: [
    { name: "eyebrow", label: "Eyebrow (optional)", type: "text", placeholder: "e.g. Details" },
    { name: "title", label: "Title (optional)", type: "text", placeholder: "Leave blank to hide the heading" },
    { name: "subtitle", label: "Subtitle (optional)", type: "textarea", placeholder: "Optional intro text above the location details" },
  ],
};

export const hasEditableChrome = (widget) => Array.isArray(WIDGET_EDITABLE[widget]) && WIDGET_EDITABLE[widget].length > 0;

// Embed widgets that expose an editable repeatable list of cards (content.items).
// Each entry defines the per-card fields shown in the admin items editor and the
// default object used when adding a new card.
export const WIDGET_ITEMS = {
  mavs_highlights: {
    label: "Athlete Highlights",
    addLabel: "Add highlight",
    defaults: { name: "New Athlete", role: "", description: "", image: "", image_alt: "" },
    fields: [
      { name: "image", label: "Photo", type: "image" },
      { name: "image_alt", label: "Photo alt text", type: "text", placeholder: "Describe the photo" },
      { name: "name", label: "Athlete name / label", type: "text", placeholder: "e.g. 16U Mavs" },
      { name: "role", label: "Title / stat", type: "text", placeholder: "e.g. Regional Finalists" },
      { name: "description", label: "Description / note", type: "textarea", placeholder: "Short note" },
      { name: "link", label: "Link (optional)", type: "text", placeholder: "/mavs-volleyball or https://…" },
    ],
  },
};

export const hasEditableItems = (widget) => !!WIDGET_ITEMS[widget];

